var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.089 19.089"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 116",
    d: "M0 5.339h19.089V-13.75H0z",
    transform: "translate(0 13.75)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 216",
    clipPath: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 114",
    d: "M7.983 15.271a7.289 7.289 0 007.288-7.288A7.289 7.289 0 007.983.694 7.289 7.289 0 00.694 7.983a7.289 7.289 0 007.289 7.288z",
    fill: "none",
    stroke: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 115",
    d: "M13.086 13.087l5.512 5.512",
    fill: "none",
    stroke: "#000"
  })))));
}

export default __webpack_public_path__ + "b4aa8e88b7678a529579d887ffe57d4d.svg";
export { SvgSearch as ReactComponent };